
import { Link } from 'react-router-dom';
import { useState } from 'react';
import ContactModal from '../../components/feature/ContactModal';

const PrivacyPolicyPage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Top Bar */}
      <div className="bg-[#003366] text-white py-2 text-xs sm:text-sm">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row justify-between items-center gap-2">
          <div className="flex items-center gap-2 text-center sm:text-left">
            <i className="ri-map-pin-line hidden sm:inline"></i>
            <span className="text-xs sm:text-sm">Serving Penobscot, Kennebec, York and Cumberland Counties</span>
          </div>
          <div className="flex items-center gap-3 sm:gap-4">
            <a href="tel:+12074783864" className="hover:text-gray-200 transition-colors cursor-pointer flex items-center gap-1 text-xs sm:text-sm">
              <i className="ri-phone-line"></i>
              (207) 478-3864
            </a>
            <button onClick={() => setIsContactModalOpen(true)} className="hover:text-gray-200 transition-colors cursor-pointer flex items-center gap-1 text-xs sm:text-sm">
              <i className="ri-mail-line"></i>
              Contact
            </button>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="bg-white border-b-4 border-[#C5A572] sticky top-0 z-50 shadow-sm">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center cursor-pointer flex-shrink-0">
              <img 
                src="https://static.readdy.ai/image/43ea3fe12e6cc98320b8be4d39ba7c8c/413fc979606f77bd03a9a24a9fc20549.png" 
                alt="Maine Roof Check Logo" 
                className="h-16 sm:h-24 md:h-32 lg:h-40 w-auto object-contain"
              />
            </Link>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-[#003366] p-2 cursor-pointer"
              aria-label="Toggle menu"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl`}></i>
            </button>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-6 xl:space-x-8">
              <Link to="/#about" className="text-[#003366] hover:text-[#C5A572] transition-colors whitespace-nowrap cursor-pointer font-medium text-sm xl:text-base">Program Overview</Link>
              <Link to="/#how-it-works" className="text-[#003366] hover:text-[#C5A572] transition-colors whitespace-nowrap cursor-pointer font-medium text-sm xl:text-base">Application Process</Link>
              <Link to="/#benefits" className="text-[#003366] hover:text-[#C5A572] transition-colors whitespace-nowrap cursor-pointer font-medium text-sm xl:text-base">Benefits</Link>
              <Link to="/#faq" className="text-[#003366] hover:text-[#C5A572] transition-colors whitespace-nowrap cursor-pointer font-medium text-sm xl:text-base">FAQ</Link>
              <Link to="/eligibility" className="bg-[#003366] text-white px-6 xl:px-8 py-2.5 xl:py-3 rounded-md font-semibold hover:bg-[#002244] transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base">
                Check Eligibility
              </Link>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
              <div className="flex flex-col space-y-3">
                <Link 
                  to="/#about" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-[#003366] hover:text-[#C5A572] transition-colors cursor-pointer font-medium py-2 px-2"
                >
                  Program Overview
                </Link>
                <Link 
                  to="/#how-it-works" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-[#003366] hover:text-[#C5A572] transition-colors cursor-pointer font-medium py-2 px-2"
                >
                  Application Process
                </Link>
                <Link 
                  to="/#benefits" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-[#003366] hover:text-[#C5A572] transition-colors cursor-pointer font-medium py-2 px-2"
                >
                  Benefits
                </Link>
                <Link 
                  to="/#faq" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-[#003366] hover:text-[#C5A572] transition-colors cursor-pointer font-medium py-2 px-2"
                >
                  FAQ
                </Link>
                <Link 
                  to="/eligibility" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="bg-[#003366] text-white px-6 py-3 rounded-md font-semibold hover:bg-[#002244] transition-colors whitespace-nowrap cursor-pointer text-center"
                >
                  Check Eligibility
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Privacy Policy Content */}
      <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="mb-8 sm:mb-12">
            <div className="inline-block bg-[#003366] text-white px-3 sm:px-4 py-2 rounded-md mb-3 sm:mb-4">
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold">Privacy Policy</h1>
            </div>
            <p className="text-sm text-gray-600">Effective Date: December 31, 2025</p>
          </div>

          <div className="space-y-8">
            {/* Who We Are */}
            <div className="border-l-4 border-[#003366] bg-gray-50 p-6 rounded-r-lg">
              <h2 className="text-xl sm:text-2xl font-bold text-[#003366] mb-4">Who We Are</h2>
              <p className="text-gray-700 leading-relaxed">
                Maine Roof Check ("we" or "us") respects your privacy. This policy describes how we collect and use your information.
              </p>
            </div>

            {/* Information We Collect */}
            <div className="border-l-4 border-[#003366] bg-gray-50 p-6 rounded-r-lg">
              <h2 className="text-xl sm:text-2xl font-bold text-[#003366] mb-4">Information We Collect</h2>
              <p className="text-gray-700 leading-relaxed">
                We collect information you voluntarily provide, including your Name, Phone Number, Email Address, and Property Address.
              </p>
            </div>

            {/* How We Use Your Information */}
            <div className="border-l-4 border-[#003366] bg-gray-50 p-6 rounded-r-lg">
              <h2 className="text-xl sm:text-2xl font-bold text-[#003366] mb-4">How We Use Your Information</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We use this data solely for the following purposes:
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-[#003366] mr-3 mt-1 flex-shrink-0"></i>
                  <span>To determine your property's preliminary eligibility for the Fortify Maine program.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-[#003366] mr-3 mt-1 flex-shrink-0"></i>
                  <span>To contact you regarding roof inspections and appointment scheduling.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-[#003366] mr-3 mt-1 flex-shrink-0"></i>
                  <span>To communicate via text message (SMS) regarding your application status.</span>
                </li>
              </ul>
            </div>

            {/* Data Protection */}
            <div className="border-l-4 border-[#003366] bg-gray-50 p-6 rounded-r-lg">
              <h2 className="text-xl sm:text-2xl font-bold text-[#003366] mb-4">Data Protection</h2>
              <p className="text-gray-700 leading-relaxed">
                We do not sell, rent, or trade your personal information to third parties or marketing agencies. Your data is shared only with certified evaluators or contractors directly involved in your specific service request.
              </p>
            </div>

            {/* Consent */}
            <div className="border-l-4 border-[#003366] bg-gray-50 p-6 rounded-r-lg">
              <h2 className="text-xl sm:text-2xl font-bold text-[#003366] mb-4">Consent</h2>
              <p className="text-gray-700 leading-relaxed">
                By submitting your information on this website or our associated forms, you consent to receive phone calls and text messages from Maine Roof Check for appointment coordination. Message and data rates may apply.
              </p>
            </div>
          </div>

          {/* Back to Home */}
          <div className="mt-12 text-center">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-[#003366] hover:text-[#C5A572] transition-colors font-semibold cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a1a1a] text-gray-300 py-8 sm:py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
            <div>
              <div className="mb-4">
                <h3 className="text-lg sm:text-xl font-bold text-white mb-1">Maine Roof Check</h3>
                <div className="h-1 w-16 bg-[#C5A572]"></div>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed">
                Privately administered application assistance service for the Fortify Maine Pilot Program.
              </p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm uppercase tracking-wider">Quick Links</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/#about" className="hover:text-white transition-colors cursor-pointer">Program Overview</Link></li>
                <li><Link to="/#how-it-works" className="hover:text-white transition-colors cursor-pointer">Application Process</Link></li>
                <li><Link to="/#benefits" className="hover:text-white transition-colors cursor-pointer">Benefits</Link></li>
                <li><Link to="/#faq" className="hover:text-white transition-colors cursor-pointer">FAQ</Link></li>
                <li><Link to="/privacy-policy" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm uppercase tracking-wider">Contact Information</h4>
              <ul className="space-y-2 text-sm">
                <li className="text-gray-400">Maine Roof Check</li>
                <li className="text-gray-400">Hermon, ME</li>
                <li>
                  <a href="tel:+12074783864" className="hover:text-white transition-colors cursor-pointer">
                    (207) 478-3864
                  </a>
                </li>
                <li>
                  <button onClick={() => setIsContactModalOpen(true)} className="hover:text-white transition-colors cursor-pointer text-left">
                    Send Message
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-700 pt-6 sm:pt-8">
            <div className="bg-gray-800 border-l-4 border-[#C5A572] p-3 sm:p-4 mb-4 sm:mb-6 rounded-r">
              <p className="text-xs sm:text-sm text-gray-300 leading-relaxed">
                <strong className="text-white">Important Disclosure:</strong> This website is operated by Maine Roof Check, a private application assistance company. We are not an agency, department, or representative of the State of Maine, Penobscot, Kennebec, York or Cumberland Counties, or any federal, state, or local government entity. We are not affiliated with, endorsed by, or sponsored by any government agency. Application assistance services are provided for a fee to help eligible homeowners navigate the Fortify Maine Pilot Program application process.
              </p>
            </div>
            <p className="text-xs text-gray-500 text-center">
              © 2026 Maine Roof Check. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Website Builder</a>
            </p>
          </div>
        </div>
      </footer>

      <ContactModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} />
    </div>
  );
};

export default PrivacyPolicyPage;
